module.exports = __webpack_public_path__ + "static/media/image-card-9.fd381d0b.png";